import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs';
import { RoleService } from '@app/shared/services/role.service';

export function userGuard(): CanActivateFn {
    return () => {
        const router = inject(Router);
        const roleService = inject(RoleService);

        return roleService.asUser$.pipe(
            map((hasAccess) => (hasAccess ? true : router.createUrlTree(['/customers']))),
            take(1),
        );
    };
}
